import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Navigationbar from "../components/Navigationbar";
import { doc, updateDoc, collection, addDoc, getDoc, getDocs, deleteDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../firebase-config";
import { getFunctions, httpsCallable } from 'firebase/functions';
import '../Styles/AdminPanel.css'
import '../Styles/button.css'
function AdminPanel () {
    const auth = getAuth();
    const navigate = useNavigate();
    const [newYear, setNewYear] = useState();
    const [companies, setCompanies] = useState([])
    const [selectedCompany, setSelectedCompany] = useState('');
    const [newCompanyName, setNewCompanyName] = useState("");
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    
      const onCreateUserbtn = () => {
          navigate('/sign-up')
        }

        useEffect(() => {
            const fetchCompanies = async () => {
              const companiesCollection = collection(db, 'companies');
              const companySnapshot = await getDocs(companiesCollection);
              const companyList = companySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
              setCompanies(companyList);
            };
            const fetchUsers = async () => {
                const usersCollection = collection(db, 'users');
                const userSnapshot = await getDocs(usersCollection);
                const userList = userSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
                setUsers(userList);
                };
                
            fetchCompanies();
            fetchUsers();
          }, []);
        
          const handleAddYear = async () => {
            try {
                const docRef = doc(db, 'years', 'ubSxV83pMcdoXr6OzCnN');
                const docSnap = await getDoc(docRef);
                let yearsArray = docSnap.data().years || [];
                const yearToAdd = Number(newYear);
                if (!yearsArray.includes(yearToAdd)) {
                    yearsArray.push(yearToAdd);
                    yearsArray.sort((a, b) => a - b);
                    await updateDoc(docRef, {
                        years: yearsArray
                    });
                    alert(`Year ${newYear} added successfully!`);
                    setNewYear(""); 
                } else {
                    alert("Year already exists!");
                }
            } catch (error) {
                console.error("Error adding year: ", error);
                alert("Failed to add year!");
            }
        };
        
        const handleAddCompany = async () => {
          try {
              
              const companiesCollection = collection(db, 'companies');
              
              
              const docRef = await addDoc(companiesCollection, {
                  company: newCompanyName
              });
      
              
              await updateDoc(docRef, {
                  companyId: docRef.id
              });
              
              alert(`Company ${newCompanyName} added successfully!`);
              setNewCompanyName("");
          } catch (error) {
              console.error("Error adding company: ", error);
              alert("Failed to add company!");
          }
      };

      const handleDeleteCompany = async () => {
        try {
          const docRef = doc(db, 'companies', selectedCompany);
          await deleteDoc(docRef);
    
          
          setCompanies(companies.filter(company => company.companyId !== selectedCompany));
    
          alert("Company removed successfully!");
        } catch (error) {
          console.error("Error removing company: ", error);
          alert("Failed to remove company!");
        }
      };


      return(
        <>
            <Navigationbar />
            <div className="container admin-container">
                <h1 className="main-header">Admin Panel</h1>
                <div className="custom-row">
                    <div className="custom-column">
                        <div className="button-container">
                        <h4 className="sub-header">Opret Bruger</h4>
                            <button onClick={onCreateUserbtn} className="generic-ea-btn">
                                Opret
                            </button>
                        </div>
                    </div>
                    <div className="custom-column">
                        <div className="add-company-container">
                        <h4 className="sub-header">Tilføj Firma</h4>
                            <input
                                className="add-company-input"
                                type="text"
                                placeholder="Tilføj nyt firma"
                                value={newCompanyName}
                                onChange={(e) => setNewCompanyName(e.target.value)}
                            />
                            <button onClick={handleAddCompany} className="generic-ea-btn">
                                Tilføj
                            </button>
                        </div>
                    </div>
                </div>
                    <div className="custom-row">
                        <div className="custom-column mt-3">
                            <div className="add-year-container">
                            <h4 className="sub-header">Tilføj år</h4>
                                    <input
                                        className="add-year-input"
                                        type="number"
                                        placeholder="f.eks: 2026"
                                        value={newYear}
                                        onChange={(e) => setNewYear(e.target.value)}
                                    />
                                    <button onClick={handleAddYear} className="generic-ea-btn">
                                        Tilføj
                                    </button>
                                
                            </div>
                        </div>
                        <div className="custom-column mt-3">
                            <div className="delete-company-container">
                                <h4 className="sub-header">Fjern Firma</h4>
                        <select
                                className="company-select"
                                value={selectedCompany}
                                onChange={(e) => setSelectedCompany(e.target.value)}
                                >
                                <option value="">Vælg Firma</option>
                                {companies.map((company) => (
                                    <option key={company.companyId} value={company.companyId}>
                                    {company.company}
                                    </option>
                                ))}
                                </select>
                                <button onClick={handleDeleteCompany} className="delete-btn">
                                Fjern
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* <div className="row">
                        <div className="delete-user-container">
                            <div className="column mt-3">
                                <h4 className="sub-header">Slet bruger</h4>
                                <select
                                    className="user-select"
                                    value={selectedUser}
                                    onChange={(e) => setSelectedUser(e.target.value)}
                                    >
                                    <option value="">Vælg bruger</option>
                                    {users.map((user) => (
                                    <option key={user.id} value={user.id}>
                                    {user.displayName || user.email}
                                    </option>
                            ))}
                                </select>
                                    <button onClick={handleDeleteUser} className="delete-btn">
                                    Slet
                                    </button>
                                </div>
                            </div>
                        </div> */}
                </div>
        </>
    )
}
export default AdminPanel;